<app-custom-header></app-custom-header>
<ion-content class="ion-padding">
  <ion-fab *ngIf="platform.is('cordova') && !isRoleUserOnly" vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button id="scan-btn" (click)="scan()">
      <div>
        <ion-icon color="light" size="large" name="bluetooth" title="Scanner" alt="Scanner"></ion-icon>
        <ion-label color="light">
          <h5>Scan</h5>
        </ion-label>
      </div>
    </ion-fab-button>
  </ion-fab>
  <ion-grid>
    <ion-row *ngIf="platform.is('cordova') && isRoleUserOnly" id="scan-row-user"
      class="ion-justify-content-center ion-align-items-center ion-hide-lg-up">
      <ion-row class="ion-align-items-center">
        <ion-col class="ion-text-center" size="12">
          <ion-button id="scan-btn-user" (click)="scan()" size="large" fill="clear">
            <ion-icon color="light" size="large" name="bluetooth" title="Scanner" alt="Scanner"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row class="ion-align-items-center">
        <ion-col class="ion-text-center" size="12">
          <ion-label>
            <h1>Scan</h1>
          </ion-label>
        </ion-col>
      </ion-row>
    </ion-row>
    <ion-row class="ion-justify-content-center" *ngIf="!isRoleUserOnly">
      <ion-col size-lg="10">
        <div class="card rounded">
          <ion-item class="rounded" lines="none">
            <ion-img slot="start" src="assets/Immeuble_Gris.svg" name="" class="xl"></ion-img>
            <ion-label>
              <h1>{{'SITE.HEADER' | translate |titlecase}}</h1>
            </ion-label>
            <ion-item-group>
              <ion-button slot="end" name="addAuth" fill="clear" routerLink="create/">
                <ion-icon src="assets/+Orange.svg">
                </ion-icon>
                &nbsp;&nbsp;
                <ion-text color="primary">
                  <div class="ion-hide-md-down">&nbsp;{{ 'SITE.CREATEBUTTON' | translate }}</div>
                  <div class="ion-hide-sm-up">&nbsp;{{ 'SITE.CREATEBUTTONSHORT' | translate }}</div>
                </ion-text>
              </ion-button>
            </ion-item-group>
          </ion-item>
          <ion-searchbar mode="ios" *ngIf="sites && sites.length > 10" type="text" (ionInput)="search($event)"
            placeholder="{{'SITE.SEARCH' | translate}}">
          </ion-searchbar>
          <ng-container *ngIf="siteSearched && siteSearched.length; else elseTemplate">
            <ion-list class="rounded">
              <ion-item class="rounded" *ngFor="let site of siteSearched" button detail="true" lines="full"
                routerLink="{{site.id}}/overview">
                <ion-icon slot="start" src="assets/IconesSolupass.svg" name="site"></ion-icon>
                <ion-label>
                  <h3>
                    {{ site.properties.name | titlecase}}
                  </h3>
                  <p>
                    {{site.properties.address}}
                  </p>
                </ion-label>
                <ion-label class="ion-hide-md-down">
                  {{site.properties.desc}}
                </ion-label>
              </ion-item>
              <ion-row *ngIf="sites.length > 5" class="ion-text-center">
                <ion-col>
                  <ion-button [disabled]="siteSearched.length === sites.length" fill="outline"
                    (click)="siteSearched = sites">Afficher plus
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-list>
          </ng-container>
          <ng-template #elseTemplate>          
            <ion-list *ngIf="!apiOk">
              <ion-item *ngFor="let item of [1,2,3,4,5]" lines="full">
                <ion-avatar slot="start">
                  <ion-skeleton-text animated></ion-skeleton-text>
                </ion-avatar>
                <ion-label>
                  <h3>
                    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                  </h3>
                  <p>
                    <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                  </p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ng-template>
        </div>
      </ion-col>
    </ion-row>
    <!-- <ion-row>
      <ion-col size-lg="10" push-lg="1">
        <div class="card rounded">
          <ion-row>
            <ion-col size-lg="8">
              <ion-item class="rounded" lines="none">
                <ion-icon slot="start" src="assets/Contour-Acces.svg" class="xl"></ion-icon>
                <ion-label>
                  <h1>{{'SITE.OVERVIEW.ACCESSES.HEADER' | translate |titlecase}}</h1>
                  <p>
                    <ion-item lines="none">
                      <ion-label>
                        <h5>{{accessCount}}</h5>
                      </ion-label>
                      <ion-label>
                        <p>{{'SITE.OVERVIEW.ACCESSES.DESC' | translate }}</p>
                      </ion-label>
                    </ion-item>
                  </p>
                </ion-label>
              </ion-item>
            </ion-col>
            <ion-col size-lg="1">
              <ion-item class="border"></ion-item>
            </ion-col>
            <ion-col size-lg="3">
              <ion-row>
                <ion-button name="addAccess" (click)="redirect('addAccess')" fill="clear">
                  <ion-icon src="assets/+Orange.svg"></ion-icon>
                  &nbsp;&nbsp;
                  <div class="ion-hide-md-down">&nbsp;{{ 'SITE.OVERVIEW.ACCESSES.CREATEBTN' | translate }}</div>
                  <div class="ion-hide-sm-up">&nbsp;{{ 'SITE.OVERVIEW.ACCESSES.CREATEBTNSHORT' | translate }}</div>
                </ion-button>
              </ion-row>
              <ion-row>
                <ion-button name="AccessesList" (click)="redirect('accessesList')" class="ion-hide-md-down"
                  fill="clear">
                  <ion-icon src="assets/>Orange.svg"></ion-icon>
                  &nbsp;&nbsp;
                  {{ 'SITE.OVERVIEW.ACCESSES.LISTBTN' | translate }}
                </ion-button>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-lg="10" push-lg="1">
        <div class="card rounded">
          <ion-row>
            <ion-col size-lg="8">
              <ion-item class="rounded" lines="none">
                <ion-icon slot="start" src="assets/Contour-Cylindres.svg" class="xl"></ion-icon>
                <ion-label>
                  <h1>{{'SITE.OVERVIEW.DEVICES.HEADER' | translate |titlecase}}</h1>
                  <p>
                    <ion-item lines="none">
                      <ion-label>
                        <h5>{{devicesCount}}</h5>
                      </ion-label>
                      <ion-label>
                        <p>{{'SITE.OVERVIEW.DEVICES.DESC' | translate }}</p>
                      </ion-label>
                    </ion-item>
                  </p>
                </ion-label>
              </ion-item>
            </ion-col>
            <ion-col size-lg="1">
              <ion-item class="border"></ion-item>
            </ion-col>
            <ion-col size-lg="3">
              <ion-row>
                <ion-button name="openDevice" fill="clear" (click)="scan()">
                  <ion-icon name="lock"></ion-icon>
                  &nbsp;&nbsp;{{ 'SITE.OVERVIEW.DEVICES.SCAN' | translate }}
                </ion-button>
              </ion-row>
              <ion-row>
                <ion-button name="devicesList" fill="clear" (click)="redirect('devicesList')" class="ion-hide-md-down">
                  <ion-icon src="assets/>Orange.svg"></ion-icon>
                  &nbsp;&nbsp;
                  {{ 'SITE.OVERVIEW.DEVICES.LISTBTN' | translate }}
                </ion-button>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row> -->
    <ion-row class="ion-justify-content-center ion-hide-md-down">
      <ion-col size="5" *ngFor="let block of blocks">
        <!-- pass -->
        <div [class]="block.class">
          <ion-row class="ion-padding">
            <ion-col size-lg="7" class="ion-align-self-center">
              <ion-item lines="none">
                <ion-icon slot="start" src="{{block.icon}}" name="{{block.iconName}}" class="xl"></ion-icon>
                <ion-label [color]="block.color">
                  <h1>{{block.title | translate |titlecase}}</h1>
                  <ion-row>
                    <ion-label class="ion-no-margin" [color]="block.color"> <strong>{{block.count}}</strong>
                    </ion-label>
                    <span class="custom-margin"></span>
                    <ion-label [color]="block.color">
                      <p>{{block.txt | translate }}</p>
                    </ion-label>
                  </ion-row>
                </ion-label>
              </ion-item>
            </ion-col>
            <ion-col size-lg="0.2" class="ion-align-self-center">
              <ion-item class="border"></ion-item>
            </ion-col>
            <ion-col size-lg="4" class="ion-align-self-center">
              <ion-row *ngFor="let link of block.links">
                <ion-button (click)="redirect(link.redirect)" fill="clear" [color]="block.color">
                  <ion-icon src="{{link.icon}}" name="{{link.iconName}}"></ion-icon>
                  &nbsp;&nbsp;
                  <div>&nbsp;{{ link.name | translate }}</div>
                </ion-button>
              </ion-row>
              <!-- <ion-row>
                <ion-button name="AccessesList" (click)="redirect('accessesList')" class="ion-hide-md-down" fill="clear"
                  color="light">
                  <ion-icon src="assets/>Blanc.svg"></ion-icon>
                  &nbsp;&nbsp;
                  {{ 'SITE.OVERVIEW.ACCESSES.LISTBTN' | translate }}
                </ion-button>
              </ion-row> -->
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>
    <!-- mobile -->
    <ion-row *ngFor="let block of blocks" class="ion-justify-content-center ion-hide-lg-up">
      <!-- pass -->
      <ion-col size="12">
        <div [class]="block.class">
          <ion-row>
            <ion-col size="4" class="ion-align-self-center">
              <ion-item lines="none">
                <ion-icon src="{{block.icon}}" name="{{block.iconName}}" class="xl"></ion-icon>
              </ion-item>
            </ion-col>
            <ion-col size="0.5" class="ion-align-self-center">
              <ion-item class="border"></ion-item>
            </ion-col>
            <ion-col size="7.5" class="ion-align-self-center">
              <ion-item lines="none">
                <ion-label [color]="block.color">
                  <h1>{{block.title | translate |titlecase}}</h1>
                  <ion-row>
                    <ion-label class="ion-no-margin" [color]="block.color"> <strong>{{block.count}}</strong>
                    </ion-label>
                    <span class="custom-margin"></span>
                    <ion-label [color]="block.color">
                      <p>{{block.txt | translate }}</p>
                    </ion-label>
                  </ion-row>
                </ion-label>
              </ion-item>
              <ion-row *ngFor="let link of block.links">
                <ion-button (click)="redirect(link.redirect)" fill="clear" [color]="block.color">
                  <ion-icon src="{{link.icon}}" name="{{link.iconName}}"></ion-icon>
                  &nbsp;&nbsp;
                  <ion-label>&nbsp;{{ link.name | translate }}</ion-label>
                </ion-button>
              </ion-row>
              <!-- <ion-row>
                <ion-button name="AccessesList" (click)="redirect('accessesList')" class="ion-hide-md-down" fill="clear"
                  color="light">
                  <ion-icon src="assets/>Blanc.svg"></ion-icon>
                  &nbsp;&nbsp;
                  {{ 'SITE.OVERVIEW.ACCESSES.LISTBTN' | translate }}
                </ion-button>
              </ion-row> -->
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>